import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './Modal.css';



function Modal(props: any) {

    if (!props.isOpen) {
        return null;
    }


    return ReactDOM.createPortal(
        <div className="Modal">
            <div className="Modal__container">
                <button onClick={props.onClose} className="Modal__close-button">
                    X
                </button>

                {props.children}

            </div>
        </div>,
        document.getElementById('modal') as HTMLElement
    );
}

export default Modal;
